import React, { useEffect, useState } from "react";
import "./Projects.css";

// Files must exist in: src/components/pictures/
const projectImages = [
  require("./pictures/p0.jpg"),
  require("./pictures/p1.jpg"),
  require("./pictures/p2.jpg"),
  require("./pictures/p3.jpg"),
  require("./pictures/p4.jpg"),
  require("./pictures/p5.jpg"),
  require("./pictures/p6.jpg"),
  require("./pictures/p7.jpg"),
  require("./pictures/p8.jpg"),
  require("./pictures/p9.jpg"),
  require("./pictures/p10.jpg"),
  require("./pictures/p11.jpg"),
  require("./pictures/p12.jpg"),
  require("./pictures/p13.jpg"),
  require("./pictures/p14.jpg"),
  require("./pictures/p15.jpg"),
  require("./pictures/p16.jpg"),
  require("./pictures/p17.jpg"),
  require("./pictures/p18.jpg"),
  require("./pictures/p19.jpg"),
  require("./pictures/p20.jpg"),
  require("./pictures/p21.jpg"),
  require("./pictures/p22.jpg"),
  require("./pictures/p23.jpg"),
  require("./pictures/p24.jpg"),
  require("./pictures/p25.jpg"),
  require("./pictures/p26.jpg"),
  require("./pictures/p27.jpg"),
  require("./pictures/p28.jpg"),
  require("./pictures/p29.jpg"),
  require("./pictures/p30.jpg"),
  require("./pictures/p31.jpg"),
  require("./pictures/p32.jpg"),
  require("./pictures/p33.jpg"),
  require("./pictures/p34.jpg"),
  require("./pictures/p35.jpg"),
  require("./pictures/p36.jpg"),
  require("./pictures/p37.jpg")
];

function Projects() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (projectImages.length === 0) return;

    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % projectImages.length);
    }, 3000); // 3s per slide

    return () => clearInterval(id);
  }, []);

  return (
    <section id="projects" className="projects-section">
      <div className="projects-header container">
        <h2 className="projects-title">Glimpse of Our Projects</h2>
        <p className="projects-subtitle">
          A brief visual glimpse of some of the homes, villas, and commercial spaces
          crafted by Maa Bhagwati Construction.
        </p>
      </div>

      <div className="projects-slider container">
        <div
          className="projects-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {projectImages.map((imgSrc, idx) => (
            <div className="project-slide" key={idx}>
              <img
                src={imgSrc}
                alt={`Project ${idx + 1}`}
                className="project-image"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
